var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 504.38 295.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M252.19 4.44c38.32,0 69.37,31.06 69.37,69.37 0,38.31 -31.05,69.37 -69.37,69.37 -38.31,0 -69.37,-31.06 -69.37,-69.37 0,-38.31 31.06,-69.37 69.37,-69.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.19 155.43c53.2,0 98.76,38.06 117.71,92.06 -30.47,29.44 -71.96,47.55 -117.71,47.55 -45.75,0 -87.24,-18.11 -117.71,-47.55 18.95,-54 64.51,-92.06 117.71,-92.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.86 0c31.42,0 56.88,25.47 56.88,56.88 0,31.41 -25.46,56.88 -56.88,56.88 -31.41,0 -56.88,-25.47 -56.88,-56.88 0,-31.41 25.47,-56.88 56.88,-56.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.86 123.81c43.63,0 80.98,31.2 96.52,75.48 -24.98,24.14 -59,38.99 -96.52,38.99 -6.54,0 -12.97,-0.45 -19.27,-1.33 -11.37,-30.34 -30.85,-57.12 -56,-75.72 18.97,-23.06 45.68,-37.42 75.27,-37.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.52 0c31.42,0 56.88,25.47 56.88,56.88 0,31.41 -25.46,56.88 -56.88,56.88 -31.41,0 -56.88,-25.47 -56.88,-56.88 0,-31.41 25.47,-56.88 56.88,-56.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.52 123.81c29.59,0 56.29,14.37 75.27,37.43 -25.15,18.6 -44.62,45.38 -55.99,75.71 -6.3,0.88 -12.74,1.33 -19.28,1.33 -37.51,0 -71.53,-14.85 -96.52,-38.99 15.54,-44.28 52.9,-75.48 96.52,-75.48z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetwork);
export default __webpack_public_path__ + "static/media/icon-network.980c901c89481f26f5f27ca792673c9c.svg";
export { ForwardRef as ReactComponent };